import React from 'react';
import '../styles/cta.scss';
import arrow from '../assets/linkArrow.svg';

const Cta = () => {
  return (
    <div className="cta" id="cta">
      <div className="cta__bg" />
      <div className="cta__text">
        <div className="line" style={{ marginBottom: '1rem' }} />
        <p>
          Morgan Stanley believes that everyone should have an opportunity to participate in the
          future $1 trillion space economy, and they are committed to building solutions that make
          life in the stars —{' '}
          <a
            href="https://www.morganstanley.com/articles/investing-with-impact?cid=mg-cap-cnncreat-12576"
            target="_blank"
            rel="sponsored"
            style={{ fontFamily: 'karlaSB', textDecoration: 'underline', color: '#fff' }}
          >
            and on Earth
          </a>{' '}
          — more equitable and accessible.{' '}
          <a
            href="https://us.etrade.com/knowledge/thematic-investing/space?cid=mg-cap-cnncreat-12579"
            target="_blank"
            rel="sponsored"
            style={{ fontFamily: 'karlaSB', textDecoration: 'underline', color: '#fff' }}
          >
            Find out how you can begin investing in space today.
          </a>{' '}
        </p>
        <div className="cta__text__link">
          <a
            href="https://www.morganstanley.com/Themes/global-space-economy/?cid=mg-cap-cnncreat-12577"
            target="_blank"
            rel="sponsored noopener"
            className="bottomLink"
          >
            explore the new space economy
          </a>
          <img src={arrow} alt="arrow" className="arrow" />
        </div>
      </div>
    </div>
  );
};

export default Cta;
